import { createSelector } from "reselect";
import { AppState } from "../reducers/rootReducer";

const getBookButtonLoading = (state: AppState) => state.bookButton.loading;

export const getBookButtonLoadingSelector = createSelector(
  getBookButtonLoading,
  (loading) => loading
);